import React, { useState, useEffect } from "react";
import api from "../../services/api";
import { Content, Main } from "../../components/Layout";
import { Row, Col } from "react-bootstrap";
import Slct from "../../components/Slct";
import Loading from "../../components/Loading";
import Pagenation from "../../components/Pagenation";
import useWrapper from "../../hooks/useWrapper";
import useFormat from "../../hooks/utils/useFormat";
import { InputText, InputDocument, InputEmail } from "../../components/Input";
import { toast } from "react-toastify";
import Button from "../../components/Button";
import TableResponsive from "../../components/TableResponsive";
import Accordion2 from "../../components/Accordion";
import ButtonLink from "../../components/Button/ButtonLink";

export default function Suppliers() {
  const { config, setbreadcrumb, permissions } = useWrapper();
  const { formatPhone, formatQuery } = useFormat();

  const [isWaitingResponse, setisWaitingResponse] = useState(true);
  const [isLoadingEssential, setisLoadingEssential] = useState(true);
  const [isLoadingTrainees, setisLoadingTrainees] = useState(false);
  const [isLoadingCities, setisLoadingCities] = useState(false);
  useEffect(() => {
    setisWaitingResponse(isLoadingEssential || isLoadingTrainees);
  }, [isLoadingEssential, isLoadingTrainees]);

  const [suppliers, setsuppliers] = useState();
  const filter_init = {};
  const [filter, setfilter] = useState(filter_init);
  const applyFilter = async (__filter, __setPreset) => {
    document.querySelector("#page-filter .accordion-button[aria-expanded='true']")?.click();
    try {
      setisLoadingTrainees(true);
      const _filter = __filter || filter;
      if (!!__filter) setfilter(__filter);
      const { event_id, category_id, ...query } = _filter;
      const _query = `?joins=null&paginate=true&${formatQuery({
        ...query,
      })}`;
      const { data: _suppliers } = await api.get(`providers${_query}`, config);
      setsuppliers(_suppliers);
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Problemas ao tentar carregar os fornecedores.");
    } finally {
      setisLoadingTrainees(false);
    }
  };

  const [states, setstates] = useState([]);
  const [events, setevents] = useState([]);
  const [resources, setresources] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        setisLoadingEssential(true);
        const { data: _states } = await api.get("state");
        setstates(
          [{ value: null, label: "-- Todos --" }].concat(
            _states.map(__state => ({
              value: __state.id,
              label: __state.name,
              uf: __state.uf,
            })),
          ),
        );
        const { data: _categories } = await api.get("categories?only_attendance=0", config);
        setevents(
          [
            {
              label: " ",
              options: [
                {
                  label: "-- Todos --",
                  value: null,
                  category_id: null,
                },
              ],
            },
          ].concat(
            _categories?.data?.map(__category => ({
              label: __category.name,
              options: __category.event?.map(__event => ({
                value: __event.id,
                label: __event.name,
                category_id: __category.id,
              })),
            })),
          ),
        );
        const _resources = _categories?.data?.reduce(
          (__acc, __category) =>
            __acc.concat(
              __category?.resource?.map(__resource => ({
                value: __resource.id,
                label: __resource.name,
                category_id: __category.id,
              })),
            ),
          [],
        );
        setresources(_resources);
      } catch (__error) {
        console.log("__error", __error);
        toast.error("Erro ao tentar carregar a lista de eventos e recursos.");
      } finally {
        setisLoadingEssential(false);
        applyFilter(filter);
      }
    })();
    // Run once on mount to load initial filter options and apply the initial filter.
    // `config` comes from context and is recreated on every render, and `applyFilter`
    // closes over `filter`, so adding them here would cause the fetch to loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [cities, setcities] = useState();
  useEffect(() => {
    if (filter?.state_id) {
      (async () => {
        try {
          setisLoadingCities(true);
          const { data: _cities } = await api.get(`cities/${filter.state_id}`);
          setcities(
            [{ value: null, label: "-- Todas --" }].concat(
              _cities.map(__city => ({
                value: __city.id,
                label: __city.name,
              })),
            ),
          );
        } catch (__error) {
          console.log("__error", __error);
          toast.error("Erro ao tentar carregar as cidades.");
        } finally {
          setisLoadingCities(false);
        }
      })();
    } else {
      setcities([]);
    }
  }, [filter?.state_id]);

  useEffect(() => {
    setbreadcrumb([{ label: "Fornecedores" }]);
  }, [setbreadcrumb]);

  return (
    <Main>
      {!isLoadingEssential ? (
        <Content>
          <Row>
            <Col>
              <h2 className="mini-title">Fornecedores:</h2>
              <p className="small-label mb-3">
                Confira todas os fornecedores registradas, com informações essenciais e acesso a detalhes completos
                sobre cada um.
              </p>
            </Col>
            {permissions?.suppliers?.create && (
              <Col sm={3}>
                <div className="d-flex align-items-start justify-content-end h-100">
                  <ButtonLink color="primary" to="/suppliers/new">
                    Cadastrar Fornecedor
                  </ButtonLink>
                </div>
              </Col>
            )}
          </Row>
          <Accordion2 id="page-filter">
            <Accordion2.Item eventKey={`page-filter`}>
              <Accordion2.Header>
                <span>Filtro</span>
                <Accordion2.Extras>
                  <span>{suppliers?.total} resultados</span>
                </Accordion2.Extras>
              </Accordion2.Header>
              <Accordion2.Body>
                <Row>
                  <Col sm={3}>
                    <span>Nome</span>
                    <InputText
                      disabled={!!isWaitingResponse}
                      placeholder="..."
                      value={filter?.name}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          name: __ev.target.value,
                        });
                      }}
                    />
                  </Col>
                  <Col sm={3}>
                    <span>E-Mail</span>
                    <InputEmail
                      disabled={!!isWaitingResponse}
                      value={filter?.email}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          email: __ev.target.value,
                        });
                      }}
                      placeholder="usuario@email.com"
                    />
                  </Col>
                  <Col sm={3}>
                    <span>Tipo de Registro</span>
                    <Slct
                      isDisabled={!!isWaitingResponse}
                      options={[
                        { value: null, label: "-- Todos --" },
                        { value: "cpf", label: "Pessoa Física" },
                        { value: "cnpj", label: "Pessoa Jurídica" },
                      ]}
                      value={filter?.document_type}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          document_type: __ev.value,
                          document: null,
                        });
                      }}
                      placeholder="..."
                    />
                  </Col>
                  {filter?.document_type && (
                    <Col sm={3}>
                      <span>{filter?.document_type === "cpf" ? "CPF" : "CNPJ"}</span>
                      <InputDocument
                        disabled={!!isWaitingResponse}
                        type={filter?.document_type}
                        value={filter?.document || ""}
                        valueChange={__ev => {
                          setfilter({
                            ...filter,
                            document: __ev,
                          });
                        }}
                      />
                    </Col>
                  )}
                </Row>
                <Row className="mt-2">
                  <Col sm={3}>
                    <span>Evento</span>
                    <Slct
                      isDisabled={!!isWaitingResponse}
                      options={events || []}
                      value={filter?.event_id}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          event_id: __ev.value,
                          category_id: __ev.category_id,
                          "resources.id": null,
                        });
                      }}
                      formatGroupLabel={true}
                      placeholder="..."
                    />
                  </Col>
                  <Col sm={3}>
                    <span>Recurso</span>
                    <Slct
                      isDisabled={!!isWaitingResponse}
                      options={[
                        {
                          label: "-- Todos --",
                          value: null,
                        },
                      ].concat(resources?.filter(__resource => __resource.category_id === filter?.category_id) || [])}
                      value={filter?.["resources.id"]}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          "resources.id": __ev.value,
                        });
                      }}
                      placeholder="..."
                    />
                  </Col>
                  <Col sm={3}>
                    <span>Estado</span>
                    <Slct
                      isDisabled={!!isWaitingResponse}
                      options={states || []}
                      placeholder="..."
                      value={filter?.state_id}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          state_id: __ev.value,
                          city_id: null,
                        });
                      }}
                    />
                  </Col>
                  <Col sm={3}>
                    <span>Cidade</span>
                    {!isLoadingCities ? (
                      <Slct
                        isDisabled={!!isWaitingResponse}
                        options={cities || []}
                        placeholder="..."
                        value={filter?.city_id}
                        onChange={__ev => {
                          setfilter({
                            ...filter,
                            city_id: __ev.value,
                          });
                        }}
                      />
                    ) : (
                      <Loading small />
                    )}
                  </Col>
                </Row>
                {!isWaitingResponse && (
                  <Row className="mt-3">
                    <Col>
                      <Button
                        color="primary"
                        size="sm"
                        onClick={() => {
                          applyFilter();
                        }}
                      >
                        Aplicar Filtro
                      </Button>
                      <Button
                        color="grey"
                        size="sm"
                        onClick={() => {
                          applyFilter(filter_init);
                        }}
                      >
                        Limpar Filtro
                      </Button>
                    </Col>
                  </Row>
                )}
              </Accordion2.Body>
            </Accordion2.Item>
          </Accordion2>

          <Row className="mt-4">
            <Col>
              {!isLoadingTrainees ? (
                <>
                  <TableResponsive
                    emptyMsg="Nenhuma formando encontrado."
                    table={{
                      head: [{ data: "ID" }, { data: "Fornecedor" }, { data: "Responsável" }, { data: "Contato" }],
                      body:
                        suppliers?.data?.map(__supplier => {
                          return {
                            link: `/suppliers/edit/${__supplier.id}`,
                            data: [
                              { element: __supplier.id },
                              { element: __supplier.name },
                              { element: __supplier.name_responsible },
                              {
                                element: (
                                  <>
                                    <p className="m-0">{formatPhone(__supplier?.cell)}</p>
                                    <p className="m-0">{__supplier?.email}</p>
                                  </>
                                ),
                              },
                            ],
                          };
                        }) || [],
                    }}
                  />
                  <Pagenation
                    current={suppliers?.page}
                    total={suppliers?.lastPage}
                    pageChange={__page => {
                      applyFilter({
                        ...filter,
                        page: __page,
                      });
                    }}
                    className="mt-4"
                  />
                </>
              ) : (
                <Loading />
              )}
            </Col>
          </Row>
        </Content>
      ) : (
        <Content>
          <Loading />
        </Content>
      )}
    </Main>
  );
}
